export default "__VITE_ASSET__CPuX5BLy__"